import React from 'react';
import { Polyline } from 'react-leaflet';
import AircraftInfoPopup from './AircraftInfoPopup';

// Shared by the arrivals, Departures and On Ground tabs for the clicked row: the landing + ground
// track on the map, and the Live page's aircraft popup beside it. Fed by useLandingTrack.

function accentColour() {
  if (typeof window === 'undefined') return '#FF6B35';
  // Leaflet pathOptions need a literal colour, so read the theme variable off the root.
  return getComputedStyle(document.documentElement).getPropertyValue('--accent-primary').trim() || '#FF6B35';
}

/** The trimmed track, in the theme accent. Render inside the MapContainer. */
export function LandingTrackLine({ positions }) {
  if (!positions || positions.length < 2) return null;
  return <Polyline positions={positions} pathOptions={{ color: accentColour(), weight: 3, opacity: 0.9 }} />;
}

/**
 * The Live page's AircraftInfoPopup for the clicked row. Render inside the map's wrapper (it is
 * absolutely positioned bottom-left of it). Until the track response lands it shows the live-feed
 * fields when the aircraft is in the feed; the photo and details arrive with the response.
 */
export function LandingTrackPopup({ hex, track, liveAircraft }) {
  if (!hex || !track.popupOpen) return null;
  const liveKey = liveAircraft
    ? [hex.toLowerCase(), hex.toUpperCase(), hex].find(k => liveAircraft[k])
    : null;
  if (!track.trackData && !liveKey) return null;
  return (
    <AircraftInfoPopup
      trackData={track.trackData}
      selectedAircraftHex={liveKey || hex}
      liveAircraftData={liveAircraft}
      onClose={track.closePopup}
    />
  );
}
